import { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, MaskLines, SectionLabel } from "./Reveal";
import { useLang } from "../i18n";

const IMGS = ["/img/camel.jpg", "/img/erg.jpg", "/img/salt.jpg", "/img/gabes.jpg", "/img/arch.jpg", "/img/canyon.jpg"];

export const Itineraries = () => {
  const { t, lang } = useLang();
  const [active, setActive] = useState(0);
  const list = t.routes.list;
  return (
    <section id="routes" className="relative py-16 md:py-40 bg-[#14120E] overflow-hidden" data-testid="routes-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <Reveal><SectionLabel index="03">{t.routes.label}</SectionLabel></Reveal>
            <h2 key={lang} className="mt-8 font-display text-4xl sm:text-5xl lg:text-7xl leading-[1] text-[#F7F4EE] max-w-3xl">
              <MaskLines lines={[t.routes.title]} />
            </h2>
          </div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6C594]/80">{t.routes.hint} ↓</p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6 lg:order-2 lg:sticky lg:top-28">
            <div className="relative aspect-[4/3] lg:aspect-[4/5] overflow-hidden spotlight-frame" data-testid="route-image">
              {IMGS.map((src, i) => (
                <motion.img
                  key={src} src={src} alt={list[i][0]}
                  initial={false}
                  animate={{ opacity: active === i ? 1 : 0, scale: active === i ? 1 : 1.12 }}
                  transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              ))}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <span className="font-display italic text-3xl md:text-4xl text-[#F7F4EE]">{list[active][0]}</span>
                <span className="font-mono text-xs text-[#F3E5AB]">0{active + 1} / 0{list.length}</span>
              </div>
            </div>
          </div>
          <ul className="lg:col-span-6 lg:order-1 border-t border-[#D4AF37]/15">
            {list.map(([name, desc], i) => (
              <li key={name} className="border-b border-[#D4AF37]/15">
                <button
                  onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)}
                  data-testid={`route-item-${i}`}
                  className="w-full text-left py-6 md:py-8 flex items-baseline gap-6 group"
                >
                  <span className={`font-mono text-xs transition-colors duration-300 ${active === i ? "text-[#D4AF37]" : "text-[#8F877A]"}`}>0{i + 1}</span>
                  <span className="flex-1">
                    <span className={`block font-display text-3xl sm:text-4xl md:text-5xl transition-[color,transform] duration-500 ${active === i ? "text-gold-grad translate-x-3" : "text-[#F7F4EE]/75 group-hover:text-[#F7F4EE]"}`}>{name}</span>
                    <motion.span
                      initial={false}
                      animate={{ height: active === i ? "auto" : 0, opacity: active === i ? 1 : 0 }}
                      className="block overflow-hidden"
                    >
                      <span className="block pt-3 pl-3 text-sm text-[#CFC6B6] max-w-md">{desc}</span>
                    </motion.span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
